import React, { useEffect, useState, useContext } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Nav, Offcanvas } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Image from "react-bootstrap/Image";
import Logo from "../images/newimg/newlogo.svg";
import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";
import UserAvatar from "../common/UserAvatar";
import AOS from "aos";
import ConstConfig from "../../utility/configs/constConfig";
import ImageConfig from "../../utility/configs/imageConfig";

const Header = () => {
  // LOGICAL VARIABLES
  useEffect(() => {
    AOS.init({
      disable: true,
      once: true,
    });
    return () => AOS.refresh();
  }, []);
  const { user, setAuthRole, setShowOtpModal } = useContext(AuthContext);
  const { enctyptDataFun, logOut } = Functions();

  const navigate = useNavigate();

  const isUserDetails = user.details != null;
  const userDetails = user.details;
  const role = isUserDetails ? user.details.role : "";
  const isRoleTherapist = role == "Therapist";
  const isRolePatient = role == "Patient";
  const location = useLocation(); // once ready it returns the 'window.location' object
  const [url, setUrl] = useState(null);
  const current_url_path = location.pathname;
  const isCurrentPageIsHome = current_url_path == "/";
  const isPhoneFound =
    userDetails?.phone && userDetails.phone.toString().trim() != "";
  const isChangePhone = isPhoneFound;
  const PhoneFieldTitle = isChangePhone ? "Update Number" : "Add Number";

  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleOffcanvasClose = () => setShowOffcanvas(false);
  const handleOffcanvasShow = () => setShowOffcanvas(true);
  const HomeLink = "/";

  // Scroll To Top
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="xl" id="home" className={`sticky-navbar ${scrolling ? "scrolled" : ""}`}>
      <Container fluid>
        <Navbar.Brand as={Link} to={HomeLink}>
          <Image src={Logo} width="160" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="offcanvasNavbar"
          onClick={handleOffcanvasShow}
        />
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          show={showOffcanvas}
          onHide={handleOffcanvasClose}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              id="offcanvasNavbarLabel"
              as={Link}
              to={HomeLink}
              onClick={handleOffcanvasClose}
            >
              <Image src={Logo} width="160" />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="mrRight">
            <Nav className="align-items-center">
              {/* <Nav.Link
                className={"underline" + (url === "" ? " header_active_tab" : "")}
                as={Link}
                to={
                  isUserDetails
                    ? isRoleTherapist
                      ? "/dashboard"
                      : isRolePatient
                      ? "/dashboard"
                      : "/"
                    : "/"
                }
                onClick={handleOffcanvasClose} // Close the Offcanvas
              >
                Home
              </Nav.Link> */}

              {isUserDetails && (
                <Nav.Link
                  as={Link}
                  className={
                    "underline avatarUser show_hide_profile_link" +
                    (url === "/patientEditProfile" ||
                    url === "/therapisteditProfile"
                      ? " header_active_tab"
                      : "")
                  }
                  to={
                    isCurrentPageIsHome
                      ? "/dashboard"
                      : isRoleTherapist
                      ? "/therapisteditProfile"
                      : isRolePatient
                      ? "/patientEditProfile"
                      : ""
                  }
                  onClick={() => {
                    handleOffcanvasClose();
                  }}
                >
                  <UserAvatar
                    profileImage={isUserDetails && userDetails.profile_img ? userDetails.profile_img : ""}
                    firstName={isUserDetails ? userDetails.first_name : ""}
                    lastName={isUserDetails ? userDetails.last_name : ""}
                    size="lg"
                    className="avatar-lg rounded-circle"
                    alt={isUserDetails ? `${userDetails.first_name} ${userDetails.last_name}` : "User"}
                  />
                  <span className="user_name_header">
                    {isUserDetails &&
                      userDetails.first_name &&
                      `${userDetails.first_name} ${userDetails.last_name}`}
                  </span>
                </Nav.Link>
              )}

              {isUserDetails && (
                <Nav.Link
                  className={
                    "underline hide_show" +
                    (url === "/dashboard" ? " header_active_tab" : "")
                  }
                  to="/dashboard"
                  as={Link}
                  onClick={handleOffcanvasClose} // Close the Offcanvas
                >
                  Appointments
                </Nav.Link>
              )}
              {isUserDetails && isRoleTherapist && (
                <>
                  <Nav.Link
                    className={
                      "underline hide_show" +
                      (url === "/therapistearnings" ? " header_active_tab" : "")
                    }
                    to="/therapistearnings"
                    as={Link}
                    onClick={handleOffcanvasClose} // Close the Offcanvas
                  >
                    Earnings
                  </Nav.Link>
                  <Nav.Link
                    className={
                      "underline hide_show" +
                      (url === "/therapistbankdetails"
                        ? " header_active_tab"
                        : "")
                    }
                    to="/therapistbankdetails"
                    as={Link}
                    onClick={handleOffcanvasClose} // Close the Offcanvas
                  >
                    Direct Deposit
                  </Nav.Link>
                </>
              )}

              {isUserDetails && (
                <>
                  <Nav.Link
                    className={
                      "underline hide_show" +
                      (url === "/chat" ? " header_active_tab" : "")
                    }
                    to="/chat"
                    as={Link}
                    onClick={handleOffcanvasClose} // Close the Offcanvas
                  >
                    Messages
                  </Nav.Link>
                  <Nav.Link
                    className={
                      "underline hide_show" +
                      (url === "/notificationsettings"
                        ? " header_active_tab"
                        : "")
                    }
                    to="/notificationsettings"
                    as={Link}
                    onClick={handleOffcanvasClose} // Close the Offcanvas
                  >
                    Notification Settings
                  </Nav.Link>
                </>
              )}
              {userDetails && (
                <Nav.Link
                  as={Link}
                  className="underline hide_show"
                  onClick={() => {
                    setShowOtpModal(true);
                    handleOffcanvasClose();
                  }} // Close the Offcanvas
                >
                  {PhoneFieldTitle}
                </Nav.Link>
              )}
              {isUserDetails && isRolePatient && (
                <>
                  <Nav.Link
                    className={
                      "underline hide_show" +
                      (url === "/patientfavourite" ? " header_active_tab" : "")
                    }
                    to="/patientfavourite"
                    as={Link}
                    onClick={handleOffcanvasClose} // Close the Offcanvas
                  >
                    Favorites
                  </Nav.Link>

                  <Nav.Link
                    className={
                      "underline hide_show" +
                      (url === "/paymentsettings" ? " header_active_tab" : "")
                    }
                    to="/paymentsettings"
                    as={Link}
                    onClick={handleOffcanvasClose} // Close the Offcanvas
                  >
                    Payment Information
                  </Nav.Link>
                </>
              )}
              <div className="divide_line" />
              <Nav.Link
                className={
                  "underline" + (url === "/about" ? " header_active_tab" : "")
                }
                as={Link}
                to="/about"
                onClick={handleOffcanvasClose} // Close the Offcanvas
              >
                About Us
              </Nav.Link>
              {isUserDetails && isRolePatient ? (
                <Nav.Link
                  className={
                    "underline" +
                    (url === "/findtherapist" ? " header_active_tab" : "")
                  }
                  as={Link}
                  to="/findtherapist"
                  onClick={handleOffcanvasClose} // Close the Offcanvas
                >
                  Find Therapists
                </Nav.Link>
              ) : (
                !isUserDetails && (
                  <Nav.Link
                    className={
                      "underline" +
                      (url === "/findtherapist" ? " header_active_tab" : "")
                    }
                    as={Link}
                    to="/findtherapist"
                    onClick={handleOffcanvasClose} // Close the Offcanvas
                  >
                    Find Therapists
                  </Nav.Link>
                )
              )}
              {(!isUserDetails || isRoleTherapist) && (
                <Nav.Link
                  className={
                    "underline" +
                    (url === "/therapist" ? " header_active_tab" : "")
                  }
                  as={Link}
                  to="/therapist"
                  onClick={handleOffcanvasClose} // Close the Offcanvas
                >
                  For Therapists
                </Nav.Link>
              )}
              <Nav.Link
                className={
                  "underline" + (url === "/news" ? " header_active_tab" : "")
                }
                as={Link}
                to="/news"
                onClick={handleOffcanvasClose} // Close the Offcanvas
              >
                News
              </Nav.Link>
              <Nav.Link
                as={Link}
                className={
                  "underline" +
                  (url === "/contactus" ? " header_active_tab" : "")
                }
                to="/contactus"
                onClick={handleOffcanvasClose} // Close the Offcanvas
              >
                Contact Us
              </Nav.Link>

              {isUserDetails && (
                <Nav.Link
                  className={"underline hide_show"}
                  as={Link}
                  to="/news"
                  onClick={() => {
                    logOut();
                    handleOffcanvasClose();
                  }} // Close the Offcanvas
                >
                  Log Out
                </Nav.Link>
              )}
              {
                <div className="btnBox">
                  {!isUserDetails && (
                    <Button
                      variant="primary"
                      className="me-2"
                      onClick={() => {
                        navigate("/login");
                        setAuthRole("Patient");
                        localStorage.setItem(
                          "E_C_R_O_L_E",
                          enctyptDataFun("Patient")
                        );
                        handleOffcanvasClose();
                      }}
                    >
                      User Login
                    </Button>
                  )}
                  {!isUserDetails && (
                    <Button
                      onClick={() => {
                        setAuthRole("Therapist");
                        localStorage.setItem(
                          "E_C_R_O_L_E",
                          enctyptDataFun("Therapist")
                        );
                        navigate("/login");
                        handleOffcanvasClose();
                      }}
                      variant="outline-primary"
                    >
                      Therapist Login
                    </Button>
                  )}
                </div>
              }

              {isUserDetails && (
                <Nav.Link
                  as={Link}
                  className={
                    "underline avatarUser show_hide_profile_link2" +
                    (url === "/patientEditProfile" ||
                    url === "/therapisteditProfile"
                      ? " header_active_tab"
                      : "")
                  }
                  to={
                    isCurrentPageIsHome
                      ? "/dashboard"
                      : isRoleTherapist
                      ? "/therapisteditProfile"
                      : isRolePatient
                      ? "/patientEditProfile"
                      : ""
                  }
                  onClick={() => {
                    handleOffcanvasClose();
                  }}
                >
                  <UserAvatar
                    profileImage={isUserDetails && userDetails.profile_img ? userDetails.profile_img : ""}
                    firstName={isUserDetails ? userDetails.first_name : ""}
                    lastName={isUserDetails ? userDetails.last_name : ""}
                    size="lg"
                    className="avatar-lg rounded-circle"
                    alt={isUserDetails ? `${userDetails.first_name} ${userDetails.last_name}` : "User"}
                  />
                  <span className="user_name_header">
                    {isUserDetails &&
                      userDetails.first_name &&
                      `${userDetails.first_name} ${userDetails.last_name}`}
                  </span>
                </Nav.Link>
              )}
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default Header;
